export const name = '@bigmi/core'
export const version = '0.8.0'
